<app-test></app-test>
<nav class="navbar fixed-top navbar-expand-lg navbar-dark bg-primary">
  <a class="navbar-brand" style="margin-left: 30px;"> Employés :</a>
  <div class="collapse navbar-collapse">
    <ul class="navbar-nav mr-auto">
    </ul>
      <ul class="navbar-nav">
      </ul>
  </div>
</nav>

<main style="margin-top: 5%;">

  <mat-card style="margin: 15px;">

    <div style="margin: 15px;">
      <mat-form-field class="example-full-width" style="width: 25%;">
       <input matInput placeholder="Name" [(ngModel)]="employee.employee_name">
      </mat-form-field>
      <mat-form-field class="example-full-width" style="margin-left: 20px;width: 25%;">
        <input matInput placeholder="Salary" type="number" [(ngModel)]="employee.employee_salary">
       </mat-form-field>
       <mat-form-field class="example-full-width" style="margin-left: 20px;width: 25%;">
        <input matInput placeholder="Age" type="number" [(ngModel)]="employee.employee_age">
       </mat-form-field>
      <button mat-raised-button color="primary" style="margin-left: 20px;" (click)="addNew()">Ajouter </button>
   </div>

   <div fxLayout fxLayoutAlign="left left" style="margin-left: 15px;">
    <mat-form-field fxFlex="40%">
      <input matInput type="text" (keyup)="doFilter($event.target.value)" placeholder="Filtre de recherche">
    </mat-form-field>
  </div>


    <div class="mat-elevation-z8" style="margin: 15px;">
      <table mat-table [dataSource]="dataSource" matSort style="width: 100%;">
        <!-- ID Column -->
        <ng-container matColumnDef="number">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 150px;"> No. </th>
          <td mat-cell *matCellDef="let element"> {{element.id}} </td>
        </ng-container>
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 300px;"> Nom </th>
          <td mat-cell *matCellDef="let element"> {{element.employee_name}} </td>
        </ng-container>
        <!-- Salary Column -->
        <ng-container matColumnDef="salary">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 200px;"> Salaire </th>
          <td mat-cell *matCellDef="let element"> {{element.employee_salary}} </td>
        </ng-container>
        <!-- Age Column -->
        <ng-container matColumnDef="age">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 100px;"> Age </th>
          <td mat-cell *matCellDef="let element"> {{element.employee_age}} </td>
        </ng-container>
        <ng-container matColumnDef="action" style="text-align: center;">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let i = index" > 
            <button mat-flat-button color="warn" (click)="deleteEmployee(i)">Supprimer</button>
          </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 20, 30]" showFirstLastButtons></mat-paginator>
    </div>
  </mat-card>
</main>
